import { Competition } from '@langlois/model-competition';

export function setCompetitions (state, competitions) {
	state.competitions = competitions.map(competition => new Competition(competition));
}
